// we refactored the bootstrap_modal component for the incident_report_form refactorings we did, but
// we have older efforts still using this. we should move them off it at somepoint.
// future efforts should use the shared/components/bootstrap_modal.jsx or adjust it for their needs.

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

function BootstrapModal({ title, body, footer, handleHide }) {
  const modalRef = useRef(null);
  const uuid = useRef(generateUUID()).current;

  useEffect(() => {
    const modalElement = modalRef.current;
    
    if (modalElement) {
      // Initialize Bootstrap modal
      const modalInstance = new bootstrap.Modal(modalElement, {
        backdrop: 'static',
        keyboard: false
      });
      
      modalInstance.show();
      
      // Handle hide event
      if (handleHide) {
        modalElement.addEventListener('hidden.bs.modal', handleHide);
      }
      
      // Cleanup
      return () => {
        if (handleHide) {
          modalElement.removeEventListener('hidden.bs.modal', handleHide);
        }
        modalInstance.dispose();
      };
    }
  }, [handleHide]);

  return (
    <div 
      className="modal fade" 
      id={`${uuid}_modal`} 
      tabIndex="-1" 
      role="dialog"
      aria-labelledby={`${uuid}_modal_label`}
      ref={modalRef}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title" id={`${uuid}_modal_label`}>
              {title}
            </h4>
            <button 
              type="button" 
              className="btn-close" 
              data-bs-dismiss="modal" 
              aria-label="Close"
            />
          </div>

          <div className="modal-body">
            {body}
          </div>

          <div className="modal-footer">
            {footer || (
              <button 
                type="button" 
                className="btn btn-secondary" 
                data-bs-dismiss="modal"
              >
                Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

BootstrapModal.propTypes = {
  body: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  footer: PropTypes.element,
  handleHide: PropTypes.func
};

export default BootstrapModal;